import { Divider } from '@/decodo/components/atoms/Divider';
import { Text } from '@/decodo/components/atoms/Text';

type MenuItemPricingProps = {
  price: string;
  priceUnit?: string;
  priceLabel?: string;
};

export function MenuItemPricing({
  price,
  priceUnit,
  priceLabel,
}: MenuItemPricingProps) {
  const formattedPriceUnit = priceUnit
    ?.replaceAll('-', ' ')
    .replaceAll('ww', '');

  return (
    <div className='relative col-start-3 row-span-full ml-2 flex w-[110px] gap-x-4'>
      <Divider
        showOnDark
        alignment='vertical'
        classNames={{ root: 'h-auto border-gray-dark-200' }}
      />
      <div className='flex flex-col gap-y-1'>
        {!!priceLabel && (
          <Text variant='body-s' color='gray-dark-500'>
            {priceLabel}
          </Text>
        )}
        <span className='flex items-center gap-x-1'>
          <Text
            variant='h5'
            color='gray-dark-950'
            classNames={{ wrapper: 'font-serif' }}
          >
            ${price}
          </Text>
          {!!priceUnit && (
            <Text
              variant='body-s'
              color='gray-dark-500'
              classNames={{ wrapper: 'leading-none whitespace-nowrap' }}
            >
              / {formattedPriceUnit}
            </Text>
          )}
        </span>
      </div>
    </div>
  );
}
